var map = {
	"./": 25470,
	"./development": 54128,
	"./development.ts": 54128,
	"./index": 25470,
	"./index.ts": 25470,
	"./localhost": 29237,
	"./localhost.ts": 29237,
	"./namespace": 99924,
	"./namespace.ts": 99924,
	"./production": 29813,
	"./production.ts": 29813,
	"./types": 25078,
	"./types.ts": 25078
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38391;